module.exports = __webpack_public_path__ + "static/img/1049.a15ca55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/1049.png
// module id = XpBD
// module chunks = 0